import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cancel-button-sm',
  templateUrl: './cancel-button-sm.component.html',
  styleUrls: ['./cancel-button-sm.component.scss']
})
export class CancelButtonSmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
